import { Network } from './network';

export class City {
    id: number|undefined;
    active:boolean;
    label:string;
    network:Network;
  }
  